import React from 'react'
import { useEnvironment } from '../hooks/useEnvironment'

// "Audio Trader Prism [Production]" / "[Staging]". While loading, no suffix. Anything else is "[Environment not set]".
export default function EnvironmentTitle({ className = '' }) {
  const name = useEnvironment()
  if (name === undefined) return <span className={className}>Audio Trader Prism</span>
  const label = name ? name[0].toUpperCase() + name.slice(1) : 'Environment not set'
  const flag = name === 'production' ? '' : 'env-not-production'
  return <span className={`${className} ${flag}`.trim()}>Audio Trader Prism [{label}]</span>
}
